import { defineNuxtRouteMiddleware, navigateTo } from '#app'

export default defineNuxtRouteMiddleware(async (to) => {
  if (to.name !== 'not-found') {
    return Promise.resolve()
  } else {
    const { url } = await fetch('/api/redirect?path=' + encodeURIComponent(to.path)).then((response) => {
      if (!response.ok) {
        return { url: null, code: response.status }
      }
      return response.json()
    })

    if (!url) return Promise.resolve()

    const searchParams = new URLSearchParams()
    Object.entries(to.query).forEach(([key, value]) => searchParams.append(key, value as string))

    const completeUrl = `${url}?${searchParams.toString()}`
    return navigateTo(completeUrl, { external: completeUrl.startsWith('http') })
  }
})
